'use strict';
import $ = require('jquery');

export class healthScroll {
    constructor() {
        if ($('.bulletHealthScroll').length === 0) return;

        let isPC = window.innerWidth > 768;
        if (isPC) {
            scroll();
        }

        window.matchMedia('(min-width: 768px)').addEventListener('change', (e) => {
            isPC = e.matches;
            scroll();
        });

        function scroll() {
            $('.bulletHealthScroll').each(function () {
                const element = this;
                let isDragging = false;
                let currentX = 0;
                let currentTime = 0;
                let velocity = 0;
                let velocitySpeed = 2;
                let animationId;

                $(element).on('pointerdown', function (e) {
                    isDragging = true;

                    this.setPointerCapture(e.pointerId);
                    currentX = e.clientX;
                    currentTime = performance.now();
                    cancelAnimationFrame(animationId);
                });

                $(element).on('pointermove', function (e) {
                    if (!isDragging) return;

                    const nextX = e.clientX;
                    const nextTime = performance.now();

                    this.scrollLeft -= (nextX - currentX) * velocitySpeed;

                    // 速度を計算
                    if (nextTime - currentTime > 0) {
                        velocity = (nextX - currentX) / (nextTime - currentTime);
                    }
                    currentX = nextX;
                    currentTime = nextTime;
                });

                $(element).on('pointerup pointercancel', function () {
                    isDragging = false;
                    inertia();
                });

                //慣性
                function inertia() {
                    element.scrollLeft -= velocity * 40;
                    velocity *= 0.95;
                    if (Math.abs(velocity) > 0.1) {
                        animationId = requestAnimationFrame(inertia);
                    }
                }
            });
        }
    }
}

export default healthScroll;